import React, { useRef } from 'react'
import { HeroLayout } from './RedUI'
import PendingLabResult from './PendingLabResult'
import { useUneeqState } from 'uneeq-react-core'
import { Box } from 'rebass'
import { useScrollToTopOnValueChange } from '../../hooks/useScrollToTopOnValueChange'

interface UpcomingLabTestsProps {
  items: any[]
  title: string
}

const UpcomingLabTests = ({ items, title }: UpcomingLabTestsProps) => {
  const { currentSectionDate } = useUneeqState()
  const containerRef = useRef<HTMLDivElement>(null)

  const dateCompare = (a: Date, b: Date) =>
    new Date(a).getTime() === new Date(b).getTime()

  useScrollToTopOnValueChange(currentSectionDate, containerRef, dateCompare)

  if (items.length === 0) return <div />

  return (
    <HeroLayout title={title}>
      <Box
        ref={containerRef}
        sx={{ overflowY: 'scroll' }}
        variant="redContentUnwrapped"
      >
        {items.map((labResult, index) => (
          <PendingLabResult labResult={labResult} index={index} />
        ))}
      </Box>
    </HeroLayout>
  )
}

export default UpcomingLabTests
